export const getLoadingBarTpl = () => '<div class="loadingbar"></div>'

export const getSavedEquipTpl = (hasDeleteBtn = false) => {
  const deleteBtnTpl = (hasDeleteBtn === true) ? '<button class="btn-delete" title="delete"></button>' : '';

  return `<article class="storage__equip" data-idx="{{=it.idx}}" data-base-stat-type="{{=it.baseStatType}}" data-memo-original="{{=it.memoOriginal}}">
						<div class="char">
							<div class="base">
								<img src="{{=it.classImageUrl}}" class="thumb" />

								{{? it.name }}
								<span class="name">{{=it.name}}</span>
								{{?}}

								{{? it.serverName }}<span class="server">{{=it.serverName}}</span>{{?}}<span class="level"><strong>{{=it.level}}</strong>Lv.</span>
								<span class="date">{{=it.date}}</span>
							</div>
						</div>

						<div class="equip">
							<ul>
							  {{~it.equips :value :index}}
								<li>
									<span class="item-name">{{=value.displayName}}</span>
								</li>
								{{~}}
							</ul>
						</div>

						<div class="title">{{=it.memo}}</div>

            ${deleteBtnTpl}
					</article>`;
};

export const getMyCharactersTpl = () => {
  return `<div class="wrap-items">
      {{~it :value :index}}
      <div class="items" data-server-id="{{=value.serverId}}" data-class-id="{{=value.classId}}">
        <div class="thumb"><img src="https://assets.playnccdn.com/resource/lineage/profile/char{{=value.classId}}_{{? value.gender === 0}}m{{??}}f{{?}}.png" alt=""></div>
        <div class="info"><span class="name">{{=value.name}}</span><span class="server">{{=value.serverName}}</span><span class="level">{{=value.level}}Lv</span></div>
      </div>
      {{~}}

      <div class="pagination"></div>
    </div>`;
};

export const getEquipsTpl = () => {
  return `<section class="simulator__equip">
    <header>
      <span class="icon-back" title="취소"></span>
      <h3></h3>

      <div class="util">
        {{? it.page === "default" || it.page === 'modify' }}
          <button class="btn-save">저장</button>
          <button class="btn-reset">초기화</button>

        {{?? it.page === "view" }}
          <button class="btn-modify">수정</button>
          <button class="btn-delete">삭제</button>
        {{?}}
      </div>
    </header>

    <section class="char">
      <div class="base">
        <img src="{{=it.classImageUrl}}" class="thumb" />

        {{? it.characterName }}
        <span class="name">{{=it.characterName}}</span>
        {{?}}

        {{? it.serverName }}<span class="server">{{=it.serverName}}</span>{{?}}<span class="level"><strong>{{=it.level}}</strong>Lv.</span><!-- 20200527 예산 제거 {{? it.estimateStr }}<span class="estimate">예산 <strong>{{=it.estimateStr}}</strong></span>{{?}}-->
      </div>
      <div class="wrap-button">
        <button class="button btn-totalstat">최종 스탯</button>
      </div>
      <div class="title">
        {{? it.memo }}
        <input type="text" name="" id="" placeholder="저장 목록에 표시할 제목을 입력하세요." value="{{=it.memo}}" maxlength="22">
        {{??}}
        <input type="text" name="" id="" placeholder="저장 목록에 표시할 제목을 입력하세요." maxlength="22">
        {{?}}
      </div>
    </section>

    <section class="variation">
      <!-- simulating  -->
      <!-- totalstat  -->
    </section>

    <footer></footer>
  </section>`;
};

export const getEquipSettingTpl = () => {
  return `<section class="simulating">
        <header><h3>장비 착용</h3></header>
        <article>
          <ul>
            <li id="sword_0">
              <div class="item-icon"><img src="" alt="무기"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="sword_0" data-equip_type="무기" placeholder="무기" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="weapon">search</button>
              </div>
              {{?}}
            </li>
            <li id="sword_1">
              <div class="item-icon"><img src="" alt="무기"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="sword_1" data-equip_type="무기" placeholder="무기" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="weapon1">search</button>
              </div>
              {{?}}
            </li>
            <li id="headpiece_0">
              <div class="item-icon"><img src="" alt="투구"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="headpiece_0" data-equip_type="투구" placeholder="투구" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="helmet">search</button>
              </div>
              {{?}}
            </li>
            <li id="t_shirt_0">
              <div class="item-icon"><img src="" alt="티셔츠"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="t_shirt_0" data-equip_type="티셔츠" placeholder="티셔츠" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="shirt">search</button>
              </div>
              {{?}}
            </li>
            <li id="armor_0">
              <div class="item-icon"><img src="" alt="갑옷"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="armor_0" data-equip_type="갑옷" placeholder="갑옷" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="armor">search</button>
              </div>
              {{?}}
            </li>
            <li id="cloak_0">
              <div class="item-icon"><img src="" alt="망토"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="cloak_0" data-equip_type="망토" placeholder="망토" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="cloak">search</button>
              </div>
              {{?}}
            </li>
            <li id="gloves_0">
              <div class="item-icon"><img src="" alt="장갑"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="gloves_0" data-equip_type="장갑" placeholder="장갑" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="gloves">search</button>
              </div>
              {{?}}
            </li>
            <li id="gaiter_0">
              <div class="item-icon"><img src="" alt="각반"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="gaiter_0" data-equip_type="각반" placeholder="각반" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="gaiter">search</button>
              </div>
              {{?}}
            </li>
            <li id="shield_0">
              <div class="item-icon"><img src="" alt="방패"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="shield_0" data-equip_type="방패" placeholder="방패" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="shield">search</button>
              </div>
              {{?}}
            </li>
            <li id="guard_0" class="disabled">
              <div class="item-icon"><!-- <img src="" alt="가더"> --></div>
              <div class="item-name"><input type="text" disabled="disabled" name="guard_0" data-equip_type="가더" placeholder="가더" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="guider">search</button>
              </div>
              {{?}}
            </li>
            <li id="shoulder_0">
              <div class="item-icon"><img src="" alt="견갑"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="shoulder_0" data-equip_type="견갑" placeholder="견갑" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="shoulder">search</button>
              </div>
              {{?}}
            </li>
            <li id="emblem_0">
              <div class="item-icon"><img src="" alt="휘장"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="emblem_0" data-equip_type="휘장" placeholder="휘장" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="emblem">search</button>
              </div>
              {{?}}
            </li>
            <li id="necklace_0">
              <div class="item-icon"><img src="" alt="목걸이"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="necklace_0" data-equip_type="목걸이" placeholder="목걸이" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="necklace">search</button>
              </div>
              {{?}}
            </li>
            <li id="pendant_0">
              <div class="item-icon"><img src="" alt="펜던트"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="pendant_0" data-equip_type="펜던트" placeholder="펜던트" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="pendant">search</button>
              </div>
              {{?}}
            </li>
            <li id="belt_0">
              <div class="item-icon"><img src="" alt="벨트"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="belt_0" data-equip_type="벨트" placeholder="벨트" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="belt">search</button>
              </div>
              {{?}}
            </li>
            <li id="ring_0">
              <div class="item-icon"><img src="" alt="반지"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="ring_0" data-equip_type="반지" placeholder="반지" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="ring">search</button>
              </div>
              {{?}}
            </li>
            <li id="ring_1">
              <div class="item-icon"><img src="" alt="반지"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="ring_1" data-equip_type="반지" placeholder="반지" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="ring2">search</button>
              </div>
              {{?}}
            </li>
            <li id="ring_2">
              <div class="item-icon"><img src="" alt="반지(60 Lv)"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="ring_2" data-equip_type="반지" placeholder="반지(60 Lv)" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="ring3">search</button>
              </div>
              {{?}}
            </li>
            <li id="ring_3">
              <div class="item-icon"><img src="" alt="반지(60 Lv)"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="ring_3" data-equip_type="반지" placeholder="반지(60 Lv)" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="ring4">search</button>
              </div>
              {{?}}
            </li>
            <li id="ring_4">
              <div class="item-icon"><img src="" alt="반지(95 Lv)"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="ring_4" data-equip_type="반지" placeholder="반지(95 Lv)" value=""></div>
              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="ring5">search</button>
              </div>
              {{?}}
            </li>
            <li id="ring_5">
              <div class="item-icon"><img src="" alt="반지(100 Lv)"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="ring_5" data-equip_type="반지" placeholder="반지(100 Lv)" value=""></div>
              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="ring6">search</button>
              </div>
              {{?}}
            </li>
            <li id="earring_0">
              <div class="item-icon"><img src="" alt="귀걸이"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="earring_0" data-equip_type="귀걸이" placeholder="귀걸이" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="earring">search</button>
              </div>
              {{?}}
            </li>
            <li id="earring_1">
              <div class="item-icon"><img src="" alt="귀걸이"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="earring_1" data-equip_type="귀걸이" placeholder="귀걸이" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="earring2">search</button>
              </div>
              {{?}}
            </li>
            <li id="boots_0">
              <div class="item-icon"><img src="" alt="부츠"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="boots_0" data-equip_type="부츠" placeholder="부츠" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="boots">search</button>
              </div>
              {{?}}
            </li>
            <li id="relic_0">
              <div class="item-icon"><img src="" alt="엘릭서 룬"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="relic_0" data-equip_type="엘릭서 룬" placeholder="엘릭서 룬" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="relic">search</button>
              </div>
              {{?}}
            </li>
            <li id="crest_0">
              <div class="item-icon"><img src="" alt="문장"></div>
              <div class="item-name"><input type="text" disabled="disabled" name="crest_0" data-equip_type="문장" placeholder="문장" value=""></div>

              {{? it.page === "default" || it.page === 'modify' }}
              <div class="item-util">
                <button class="btn-reset">reset</button>
                <button class="btn-search" name="crest">search</button>
              </div>
              {{?}}
            </li>
          </ul>
        </article>

        <footer>
          <div class="totalprice"><strong>0</strong> 아데나 </div>
        </footer>
      </section>`;
};

export const getTotalStatsTpl = () => {
  return `<section class="simulator__stat totalstat">
    <header>
      <span class="icon-close" title="취소"></span>
      <h3>최종 스탯</h3>
    </header>

    <section class="char char__stat">
      <div class="hpmp">
        <ul>
          <li class="hp">
            <label>HP</label>
            <span class="graph"><figure style="width:100%"></figure></span>
            <var>{{=it.hp}}</var>
          </li>

          <li class="mp">
            <label>MP</label>
            <span class="graph"><figure style="width:100%"></figure></span>
            <var>{{=it.mp}}</var>
          </li>
        </ul>
      </div>
    </section>

    <section class="variation">
      <dl class="stat_STR">
        <dt class="STR">
           <strong>STR</strong>
           <var><em class="total">{{=it.STR}}</em><span class="base"> (<span>{{=it.STR}}</span>)</span></var>
        </dt>
        <dd>
           <ul>
              <li class="DAMAGE_SHORT"><label>근거리 대미지</label><var><em class="total">{{=it.DAMAGE_SHORT}}</em><span class="base"> (<span>{{=it.DAMAGE_SHORT}}</span>)</span></var></li>
              <li class="HIT_SHORT"><label>근거리 명중</label><var><em class="total">{{=it.HIT_SHORT}}</em><span class="base"> (<span>{{=it.HIT_SHORT}}</span>)</span></var></li>
              <li class="FATAL_SHORT"><label>근거리 치명타</label><var><em class="total">{{=it.FATAL_SHORT}}</em><span class="base"> (<span>{{=it.FATAL_SHORT}}</span>)</span></var></li>
              <li class="WEIGHT"><label>최대 소지 무게</label><var><em class="total">{{=it.WEIGHT}}</em><span class="base"> (<span>{{=it.WEIGHT}}</span>)</span></var></li>
           </ul>
        </dd>
      </dl>

      <dl class="stat_DEX">
        <dt class="DEX">
          <strong>DEX</strong>
          <var><em class="total">{{=it.DEX}}</em> <span class="base"> (<span>{{=it.DEX}}</span>)</span></var>
        </dt>
        <dd>
           <ul>
              <li class="DAMAGE_LONG"><label>원거리 대미지</label><var><em class="total">{{=it.DAMAGE_LONG}}</em><span class="base"> (<span>{{=it.DAMAGE_LONG}}</span>)</span></var></li>
              <li class="HIT_LONG"><label>원거리 명중</label><var><em class="total">{{=it.HIT_LONG}}</em><span class="base"> (<span>{{=it.HIT_LONG}}</span>)</span></var></li>
              <li class="FATAL_LONG"><label>원거리 치명타</label><var><em class="total">{{=it.FATAL_LONG}}</em><span class="base"> (<span>{{=it.FATAL_LONG}}</span>)</span></var></li>
              <li class="AC"><label>물리 방어력(AC)</label><var><em class="total">{{=it.AC}}</em><span class="base"> (<span>{{=it.AC}}</span>)</span></var></li>
              <li class="ER"><label>원거리 회피력(ER)</label><var><em class="total">{{=it.ER}}</em><span class="base"> (<span>{{=it.ER}}</span>)</span></var></li>
           </ul>
        </dd>
      </dl>
      
      <dl class="stat_INT">
        <dt class="INT">
          <strong>INT</strong>
          <var><em class="total">{{=it.INT}}</em> <span class="base"> (<span>{{=it.INT}}</span>)</span></var>
        </dt>
        <dd>
           <ul>
              <li class="DAMAGE_WIZ"><label>마법 대미지</label> <var> <em class="total">{{=it.DAMAGE_WIZ}}</em> <span class="base"> (<span>{{=it.DAMAGE_WIZ}}</span>)</span> </var> </li>
              <li class="HIT_WIZ"><label>마법적중</label> <var> <em class="total">{{=it.HIT_WIZ}}</em> <span class="base"> (<span>{{=it.HIT_WIZ}}</span>)</span> </var> </li>
              <li class="FATAL_WIZ"><label>마법 치명타</label><var><em class="total">{{=it.FATAL_WIZ}}</em><span class="base"> (<span>{{=it.FATAL_WIZ}}</span>)</span></var></li>
              <li class="MB"><label>마법 보너스(MB)</label><var><em class="total">{{=it.MB}}</em><span class="base"> (<span>{{=it.MB}}</span>)</span></var></li>
              <li class="MP_MINUS"><label>MP 소모 감소</label><var><em class="total">{{=it.MP_MINUS}}</em><span class="base"> (<span>{{=it.MP_MINUS}}</span>)</span></var></li>
           </ul>
        </dd>
      </dl>

      <dl class="stat_WIS">
        <dt class="WIS">
          <strong>WIS</strong>
          <var><em class="total">{{=it.WIS}}</em> <span class="base"> (<span>{{=it.WIS}}</span>)</span></var>
        </dt>
        <dd>
           <ul>
              <li class="LEVELUP_MP_PLUS"><label>레벨업시 MP 증가</label><var><em class="total">{{=it.LEVELUP_MP_PLUS}}</em><span class="base"> (<span>{{=it.LEVELUP_MP_PLUS}}</span>)</span></var></li>
              <li class="MP_RECOVER_TIC"><label>MP 회복(틱)</label><var><em class="total">{{=it.MP_RECOVER_TIC}}</em><span class="base"> (<span>{{=it.MP_RECOVER_TIC}}</span>)</span></var></li>
              <li class="MP_RECOVER_LIQUOR"><label>MP 물약 회복(틱)</label><var><em class="total">{{=it.MP_RECOVER_LIQUOR}}</em><span class="base"> (<span>{{=it.MP_RECOVER_LIQUOR}}</span>)</span></var></li>
              <li class="MR"><label>마법 방어력(MR)</label><var><em class="total">{{=it.MR}}</em><span class="base"> (<span>{{=it.MR}}</span>)</span></var></li>
           </ul>
        </dd>
      </dl>

      <dl class="stat_CON">
        <dt class="CON">
          <strong>CON</strong>
          <var><em class="total">{{=it.CON}}</em> <span class="base"> (<span>{{=it.CON}}</span>)</span></var>
        </dt>
        <dd>
           <ul>
              <li class="LEVELUP_HP_PLUS"><label>레벨업시 HP 증가</label><var><em class="total">{{=it.LEVELUP_HP_PLUS}}</em><span class="base"> (<span>{{=it.LEVELUP_HP_PLUS}}</span>)</span></var></li>
              <li class="HP_RECOVER_TIC"><label>HP 회복(틱)</label><var><em class="total">{{=it.HP_RECOVER_TIC}}</em><span class="base"> (<span>{{=it.HP_RECOVER_TIC}}</span>)</span></var></li>
              <li class="HP_RECOVER_LIQUOR"><label>HP 물약 회복 증가</label><var><em class="total">{{=it.HP_RECOVER_LIQUOR}}</em><span class="base"> (<span>{{=it.HP_RECOVER_LIQUOR}}</span>)</span></var></li>
              <li class="WEIGHT"><label>최대 소지 무게</label><var><em class="total">{{=it.WEIGHT}}</em><span class="base"> (<span>{{=it.WEIGHT}}</span>)</span></var></li>
           </ul>
        </dd>
      </dl>

      <dl class="stat_CHA">
        <dt class="CHA">
          <strong>CHA</strong>
          <var>
            <em class="total">{{=it.CHA}}</em>
            <span class="base"> (<span>{{=it.CHA}}</span>)</span>
          </var>
        </dt>
        <dd>
           <ul>
              <li class="CHA_HIT_SIKII"><label>기술 적중</label><var><em class="total">{{=it.CHA_HIT_SIKII}}</em><span class="base"> (<span>{{=it.CHA_HIT_SIKII}}</span>)</span></var></li>
              <li class="CHA_HIT_SUMMON"><label>정령 적중</label><var><em class="total">{{=it.CHA_HIT_SUMMON}}</em><span class="base"> (<span>{{=it.CHA_HIT_SUMMON}}</span>)</span></var></li>
              <li class="CHA_HIT_DRAGON"><label>용언 적중</label><var><em class="total">{{=it.CHA_HIT_DRAGON}}</em><span class="base"> (<span>{{=it.CHA_HIT_DRAGON}}</span>)</span></var></li>
              <li class="CHA_HIT_FEAR"><label>공포 적중</label><var><em class="total">{{=it.CHA_HIT_FEAR}}</em><span class="base"> (<span>{{=it.CHA_HIT_FEAR}}</span>)</span></var></li>
              <li class="CHA_SKILL_TIME_REDUCTION"><label>스킬 쿨타임 감소</label><var><em class="total">{{=it.CHA_SKILL_TIME_REDUCTION}}</em><span class="base"> (<span>{{=it.CHA_SKILL_TIME_REDUCTION}}</span>)</span></var></li>
              <li class="CHA_STATUS_TIME_REDUCTION"><label>상태 이상 시간 감소</label><var><em class="total">{{=it.CHA_STATUS_TIME_REDUCTION}}</em><span class="base"> (<span>{{=it.CHA_STATUS_TIME_REDUCTION}}</span>)</span></var></li>
           </ul>
        </dd>
      </dl>

      <ul class="stat-base">
        <li class="SP"><label>SP</label><var><em class="total">{{=it.SP}}</em></var></li>
        <li class="DAMAGE_MINUS"><label>대미지 감소</label><var><em class="total">{{=it.DAMAGE_MINUS}}</em></var></li>
        <li class="MAX_HP_PLUS"><label>최대 HP 증가</label><var><em class="total">{{=it.MAX_HP_PLUS}}</em></var></li>
        <li class="MAX_MP_PLUS"><label>최대 MP 증가</label><var><em class="total">{{=it.MAX_MP_PLUS}}</em></var></li>
      </ul>

      <ul class="stat-property">
        <li class="FIRE"><label>불</label><var><em class="total">{{=it.FIRE}}</em></var></li>
        <li class="WATER"><label>물</label><var><em class="total">{{=it.WATER}}</em></var></li>
        <li class="STORM"><label>바람</label><var><em class="total">{{=it.STORM}}</em></var></li>
        <li class="LAND"><label>땅</label><var><em class="total">{{=it.LAND}}</em></var></li>
        <li class="HIT_SKILL"><label>기술 적중</label><var><em class="total">{{=it.HIT_SKILL}}</em></var></li>
        <li class="RES_SKILL"><label>기술 내성</label><var><em class="total">{{=it.RES_SKILL}}</em></var></li>
        <li class="HIT_SUMMON"><label>정령 적중</label><var><em class="total">{{=it.HIT_SUMMON}}</em></var></li>
        <li class="RES_SUMMON"><label>정령 내성</label><var><em class="total">{{=it.RES_SUMMON}}</em></var></li>
        <li class="HIT_DRAGON"><label>용언 적중</label><var><em class="total">{{=it.HIT_DRAGON}}</em></var></li>
        <li class="RES_DRAGON"><label>용언 내성</label><var><em class="total">{{=it.RES_DRAGON}}</em></var></li>
        <li class="HIT_FEAR"><label>공포 적중</label><var><em class="total">{{=it.HIT_FEAR}}</em></var></li>
        <li class="RES_FEAR"><label>공포 내성</label><var><em class="total">{{=it.RES_FEAR}}</em></var></li>
      </ul>
    </section>

    <footer>* 일부 수치의 경우 게임 정보와 일치하지 않을 수 있습니다. 이용에 불편을 드려 죄송합니다.</footer>
  </section>`;
};

export const getSearchEquipLayerSearchFormTpl = () => {
  return `<section class="section-searchform">
			<form id="suggestForm" method="get" action="" onsubmit="return false">
			  <!--
        <input type="hidden" id="fex1" value="투구">
        <input type="hidden" id="fex2" value="군주">
        <input type="hidden" id="slot" value="headpiece_0">
        -->

        <input type="text" value="" autocomplete="off" data-name="suggest_input" id="suggestInput" />
        <input type="button" value="X" title="삭제" data-name="suggest_delete" />
        <input type="button" value="GO" title="검색" data-name="suggest_submit" id="suggestSubmit" />

        <div data-name="suggest_wrap" class="suggest_wrap">
          <div data-name="suggest_list" class="suggest_list">
            <div data-name="suggest_scroll"><ul></ul></div>
          </div>
        </div>
			</form>
		</section>`;
};

export const getSearchEquipLayerTpl = () => {
  return `<div class="layer-item-search">
    <header>
      <span class="icon-close" title="취소"></span>
      <h3>장비 검색</h3>
    </header>

    ${getSearchEquipLayerSearchFormTpl()}

    <!-- (e) 통합 검색 -->

    <div class="wrap-section-searchresult">
      <section class="section-searchresult">
        <div class="nodata"><p>선택한 위치의 장비 아이템이 아니거나,<br>단어의 철자가 정확하지 않을 경우<br>검색 결과를 찾을 수 없습니다.</p></div>
        <ul>
          <!--
          <li>
            <div class="item-icon"><img src="http://static.plaync.co.kr/powerbook/lineage/36/93/66daabdeab40dde821d35877.jpg" alt="견갑"></div>
            <div class="item-name">+7 <strong>드래곤</strong> 은기사의 견갑</div>
            <div class="item-price">99억 1,456만 3,454</div>
          </li>
          -->
        </ul>

        <div class="pagination">
          <!--
          <button class="btn prev" disabled="disabled">이전</button>
          <span class="page"><strong>1</strong> / 1</span>
          <button class="btn next">다음</button>
          -->
        </div>
      </section>
    </div>
  </div>`;
};

export const getEquipPriceLayerTpl = () => {
  return `<div class="layer-item-marketprice-info">
      <dl>
        <dt>현재 판매가(최저)</dt>
        <dd>0</dd>
      </dl>
      <dl>
        <dt>4주 평균 판매</dt>
        <dd>0</dd>
      </dl>

      <span class="layer-close">닫기</span>
    </div>`;
};

export let orgStatsData = {};



// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/model/tpl/equip.js